//TODO: Избавиться от констант в задаче https://jira.tennisi.it/browse/SITE-739
export const NAMESPACE_LIVE = 'live';
export const NAMESPACE_PREMATCH = 'prematch';
export const NAMESPACE_PREMATCH_MATCHES = 'prematchMatches';
export const NAMESPACE_INTERESTING_MATCHES = 'interestingMatches';
export const NAMESPACE_MATCH_OF_THE_DAY = 'matchOfTheDay';
export const NAMESPACE_MATCH_RESULT = 'matchResult';
export const NAMESPACE_LANDING_MENU = 'landingMenu';
export const NAMESPACE_FAVORITES = 'favorites';
export const NAMESPACE_SEARCH = 'search';

export const enum ContextNamespace {
  LIVE = 'live',
  PREMATCH = 'prematch',
  PREMATCH_MATCHES = 'prematchMatches',
  FAVORITES = 'favorites',
  INTERESTING_MATCHES = 'interestingMatches',
  MATCH_OF_THE_DAY = 'matchOfTheDay'
}
